import { useContext } from 'react';
import { AppConfig } from '@/appConfig/AppConfigContext.ts';

export const useAppConfig = () => {
  return useContext(AppConfig);
};
